import { render } from "./App.vue?vue&type=template&id=19add248&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=19add248&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19add248"]])

export default __exports__